/**
 * Petite carte de synthèse chiffrée utilisée en haut des pages de tableaux.
 * Cliquable optionnellement (ex: filtrer le tableau associé sur ce critère).
 */
import { Card, CardContent } from "@/components/ui/card";

const TONE = { slate: "text-slate-700", red: "text-red-600", blue: "text-[#0B5394]", orange: "text-amber-600", green: "text-emerald-600" };

export default function SummaryChip({ label, value, tone = "slate", onClick, active = false, testId }) {
  const clickable = typeof onClick === "function";
  return (
    <Card
      data-testid={testId}
      onClick={onClick}
      className={`border-slate-200 p-3 transition-all ${clickable ? "cursor-pointer hover:border-[#0B5394]/40 hover:shadow-md" : ""} ${active ? "border-[#0B5394] ring-1 ring-[#0B5394]/30 bg-[#0B5394]/5" : ""}`}
    >
      <CardContent className="p-0">
        <p className="text-xs text-slate-400">{label}</p>
        <p className={`text-xl font-bold tabular-nums ${TONE[tone]}`}>{value}</p>
      </CardContent>
    </Card>
  );
}
